<template>
  <AuthShell
    title="Forgot Password"
    subtitle="Request a password reset link."
    :show-hero="false"
  >
    <div class="auth-panel__section">
      <h2 class="auth-panel__title">Request a new password</h2>
      <p class="auth-panel__helper">Enter your account email address and we will send reset instructions.</p>
    </div>

    <div v-if="message" class="auth-panel__section">
      <div class="auth-success-message" data-testid="forgot-password-message">{{ message }}</div>
    </div>

    <div v-if="errorMessage" class="auth-panel__section">
      <div class="auth-error-message" data-testid="forgot-password-error">{{ errorMessage }}</div>
    </div>

    <form class="auth-panel__section auth-form" @submit.prevent="onSubmit">
      <div class="auth-field">
        <label class="auth-label" for="forgot-password-email">Email</label>
        <input
          id="forgot-password-email"
          v-model="email"
          class="auth-input"
          data-testid="forgot-password-email"
          type="email"
          required
          autocomplete="email"
        >
      </div>

      <div class="auth-actions">
        <button
          class="auth-submit"
          data-testid="forgot-password-submit"
          type="submit"
          :disabled="isSubmitting"
        >
          {{ isSubmitting ? 'Sending…' : 'Send reset link' }}
        </button>
        <p class="auth-secondary">
          <a class="auth-link" href="/login">Back to login</a>
        </p>
      </div>
    </form>
  </AuthShell>
</template>

<script setup>
import { ref } from 'vue'
import AuthShell from '../components/AuthShell.vue'

const email = ref('')
const message = ref('')
const errorMessage = ref('')
const isSubmitting = ref(false)

const onSubmit = async () => {
  message.value = ''
  errorMessage.value = ''
  isSubmitting.value = true
  try {
    const resp = await fetch('/api/v1/auth/password-reset', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email.value }),
    })
    const data = await resp.json().catch(() => ({}))
    if (!resp.ok) {
      errorMessage.value = data.detail || 'Password reset request failed.'
      return
    }
    message.value = data.detail
  } catch (e) {
    errorMessage.value = 'Network error. Please try again.'
  } finally {
    isSubmitting.value = false
  }
}
</script>
